<template>
  <div class="bg">
    <div class="Login">
      <h2 class="f-lg f-weigh p-bottom-2 t-center">{{ title }}</h2>
      <el-input
        placeholder="账号"
        prefix-icon="el-icon-user-solid"
        v-model="formField.userName"
      >
      </el-input>
      <el-input
        show-password
        placeholder="密码"
        prefix-icon="el-icon-lock"
        v-model="formField.passWord"
        @keyup.13.native="toLogin"
      >
      </el-input>

      <div class="bottom">
        <el-button type="primary" @click="toLogin1">登录</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
    </div>

    <div class="footer">
      <div class="footer-wrapper">
        <div class="copyright">
          Copyright©2018 繁翰信息技术(上海)有限公司 版权所有 备案号:
          沪ICP备15014115号-2
        </div>
        <!-- <div class="record" style="margin: 0 16px">
          <a href="https://beian.miit.gov.cn/">
            {{ icpInfo }}
          </a>
        </div> -->
        <div class="police">
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502005110"
          >
            <img src="../../assets/images/logo_police.png" />
            <span>沪公网安备 31010502005110号</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { login, getConfig } from "../../api/login.js";
import { debounce } from "../../utils/utils";
export default {
  data() {
    return {
      formField: {
        userName: "",
        passWord: "",
      },
      title: "签到平台",
    };
  },
  created() {
    console.log(123);
    this.getConfig({ code: "Sign_Title" });
  },
  methods: {
    ...mapMutations({
      setUserInfo: "common/setUserInfo",
    }),
    getConfig(params) {
      getConfig(params).then((res) => {
        console.log(res);
        this.title = res.result.value;
      });
    },
    reset() {
      this.formField = {
        userName: "",
        passWord: "",
      };
    },
    toLogin1: debounce(async function () {
      let formField = Object.assign({}, this.formField);
      if (formField.userName == "" || formField.passWord == "") {
        this.$message.error("请填写账号或者密码！");
        return;
      }
      let result = await login(formField);
      if (result.status == 200) {
        let { token } = result.result;
        let userInfo = result.result.user;
        this.setUserInfo(userInfo);
        localStorage.setItem("token", token);
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        // const res1 = await getMenuList();
        // localStorage.setItem("menuList", JSON.stringify(res1.result));
        this.$message({
          message: "登录成功",
          type: "success",
        });
        this.timeId = setTimeout(() => {
          this.$router.push({ name: "Index" });
        }, 2000);
      } else {
        this.$message({
          message: "失败",
          type: "warning",
        });
      }
    }),
    // 这里没有使用element的form校验 下次实际开发的时候一定加上
    async toLogin() {
      let formField = Object.assign({}, this.formField);
      if (formField.userName == "" || formField.passWord == "") return;
      let result = await login(formField);
      if (result.status == 200) {
        let { token } = result.result;
        let userInfo = result.result.userInfo;
        localStorage.setItem("token", token);
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        // const res1 = await getMenuList();
        // localStorage.setItem("menuList", JSON.stringify(res1.result));
        this.$message({
          message: "登录成功",
          type: "success",
        });
        this.timeId = setTimeout(() => {
          this.$router.push({ name: "Index" });
        }, 2000);
      } else {
        this.$message({
          message: "失败",
          type: "warning",
        });
      }
    },
  },

  beforeDestroy() {
    clearTimeout(this.timeId);
  },
};
</script>

<style lang="less" scoped>
body {
  width: 100%;
  height: 100%;
}
.Login {
  width: 450px;
  border-radius: 4px;
  height: 340px;
  margin: 0 auto;
  padding: 40px;

  background-color: #fff;
  > .bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
  }
  .el-input {
    margin-top: 30px;
  }
}

.bg {
  width: 100vw;
  height: 100vh;
  padding-top: 150px;
  background-color: #f5f5f5;
  height: 100%;
  // background: url(../../assets/bg2.jpg) no-repeat;
  background-size: 100% 100%;
}
.footer {
  height: 40px;
  background: rgb(238, 238, 238);
  color: rgb(90, 90, 90);
  display: block;
  width: 100%;
  position: fixed;
  bottom: 0;
}
.footer-wrapper {
  width: 80%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}

.record a,
.police a {
  text-decoration: none;
  color: rgb(90, 90, 90);
}

.police span {
  font-size: 12px;
  line-height: 24px;
  vertical-align: text-bottom;
}
</style>
